function sanityCheckCoordinates(coordinates: any[]) {
    if (coordinates[0] > coordinates[1]) {
        return [coordinates[1], coordinates[0]];
    }
    return coordinates;
}

function makeValidGeoJson(geojson: any, properties: any = {}) {
    // Already a full collection
    if (geojson?.type === "FeatureCollection") {
        return geojson;
    } else if (geojson?.coordinates && geojson.coordinates.length === 1) {
        // Single coordinate -> Point
        return {
            type: "FeatureCollection",
            features: [{
                type: "Feature",
                properties: {...properties},
                geometry: {
                    type: "Point",
                    coordinates: sanityCheckCoordinates(geojson.coordinates[0])
                }
            }]
        };
    } else if (geojson?.coordinates) {
        // Multiple coordinates -> LineString (can be adapted to Polygon if needed)
        return {
            type: "FeatureCollection",
            features: [{
                type: "Feature",
                properties: {...properties},
                geometry: {
                    type: "LineString",
                    coordinates: geojson.coordinates.map(sanityCheckCoordinates)
                }
            }]
        };
    } else {
        throw new Error("Invalid GeoJSON input");
    }
}

export function openGeoJson(geojson: any, properties: any = {}) {
    const validGeoJson = makeValidGeoJson(geojson, properties);
    const url = `http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify(validGeoJson))}`;
    return window.open(url, '_blank');
}

export function openAllGeoJson(geojsonArray: { geojson: any, properties: any }[]) {
    const combinedGeoJson: any = {
        type: "FeatureCollection",
        features: [] as any[]
    };

    geojsonArray
        .map(({ geojson: gj, properties }) => makeValidGeoJson(gj, properties))
        .forEach((gj: any) => {
            if (gj.type === "Feature") {
                combinedGeoJson.features.push(gj);
            } else if (gj.type === "FeatureCollection" && gj.features) {
                combinedGeoJson.features.push(...gj.features);
            } else {
                console.warn("Invalid GeoJSON object:", gj);
            }
        });

    const url = `http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify(combinedGeoJson))}`;
    return window.open(url, '_blank');
}